export const reviewData= [
    {
        "id": 1,
        "name": "Lipi Chaudhuri",
        "date": "April 15, 2020",
        "body": "This app is a game changer for me. I am unable to go out always to buy medicinal products. Pharmeasy gives me the last liberty to shop essential healthcare products from home. The app is very user friendly and me being an elderly person do not find any difficulty in using it. They deliver well in time. Thanks😊"
    },
    {
        "id": 2,
        "name": "Tirthankar Das Purkayastha",
        "date": "April 23, 2020",
        "body": "Very good app. Would recommend it to everyone requiring fast and efficient delivery of medicinal products at the doorstep."
    },
    {
        "id":3,
        "name": "Debanjan Roy",
        "date": "April 18, 2020",
        "body": "Excellent experience. Pharmeasy has not let it's customers down during lockdown. Thanks team. Great job. The application is also very smooth. And does its job well with an attractive UI and easy to use features. Good job developer."
    },
    {
        "id": 4,
        "name": "Rohini Sarkar",
        "date": "April 21, 2020",
        "body": "Very helpful and friendly app in terms of usability, customer support money saving from the point of medical necessity of every person."
    },
    {
        "id": 5,
        "name": "Varun Sonagra",
        "date": "April 23, 2020",
        "body": "I've had a good experience. The consultation with a doctor feature works well too. The prices and discounts are great too. Overall the simplicity of the app is a plus too. I recommend this app. Will always be a customer/user now! Genuinely!"
    },
    {
        "id": 6,
        "name": "Rajarshi Sarkar",
        "date": "April 22, 2020",
        "body": "The app is really wonderful. Being a Product Manager myself, I would say that the User experience (UI/UX) of the app is top notch (easy to use, simple and convenient). Coming to services and delivery, I would say Pharmeasy is doing a tremendous job even during this unprecedented pandemic situation."
    },
    {
        "id": 7,
        "name": "Darpan Dholakia",
        "date": "April 23, 2020",
        "body": "Best service and app amongst all available. I have been using it for more than 3 years, and even during the pandemic, they have kept their standards high and are delivering the order within 24 hours. Keep up the good work."
    },
    
]